import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';
import {DobroRuResponse} from '../../../shared/models/api/dobroruResponseData';

export interface DobroruState {
  link: string | null;
  dataLoading: boolean;
  data: DobroRuResponse | null;
}

const initialState: DobroruState = {
  link: null,
  dataLoading: false,
  data: null,
};

export const dobroruSlice = createSlice({
  name: '@@eskmo/dobroru',
  initialState,
  reducers: {
    setLink: (state, {payload}: PayloadAction<DobroruState['link']>) => {
      state.link = payload;
    },
    setDataLoading: (state, {payload}: PayloadAction<DobroruState['dataLoading']>) => {
      state.dataLoading = payload;
    },
    setData: (state, {payload}: PayloadAction<DobroruState['data']>) => {
      state.data = payload;
    },
    reset: () => initialState,
  },
  extraReducers: {
    [AppActions.Reset]: () => initialState,
  },
});

export const dobroruActions = dobroruSlice.actions;

export const dobroru = dobroruSlice.reducer;
